export default {
  headerContent: {
    title: 'Türk Nippon Sigorta Zorunlu Trafik Sigortası Teklif Al',
    slogan: "Trafik Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TRAFİK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türk Nippon Sigorta Zorunlu Trafik Sigortası',
    description: {
      title: 'Türk Nippon Sigorta Zorunlu Trafik Sigortası Nedir? ',
      content: [
        'Türk Nippon Sigorta’dan alacağınız trafik sigortası ile karayolunda oluşacak hasarları güvence altına alabilirsiniz.',
        'Otomobil sigortası fiyatını nasıl alacağınızı veya genel olarak otomobil sigortasının nasıl çalıştığı konusunda kafanız karıştıysa veya emin değilseniz AloKasko uzmanları size yardımcı olabilir.',
        'Araç sigortasını online olarak bulmak, Alokasko.com’u kullandığınızda 5 dakikadan daha kısa sürer.'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta Zorunlu Trafik Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası sigortalı motorlu aracın karayolunda oluşabilecek kaza sonucunda karşı tarafa ve 3. Şahıslara vereceği hasar sebebiyle ortaya çıkacak hukuki sorumluluklarını güvence altına alır.',
          subList: null
        },
        {
          paragraph:
            'Otomobil sigortası sizin bütçenizi korurken bir araç kazasına karışan diğer kişileri kapsar.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Trafik Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Trafik Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Trafik Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Turk Nippon Sigorta Trafik Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
  ]
}
